// v1.17 (AS AMENDMENTS.v1.17, approved 2026-11-04): the card status and renewals the server adds to GET /billing when
// `billing.cardValidity` is on. The server decides the status; this file only words it. Billing admins get brand, last 4
// and expiry; other members the status only. Absent keys (flag off) mean nothing new is shown.

/** One label and status-dot tone per server status. */
export const CARD_STATUS_DISPLAY = Object.freeze({
	VALID: { label: 'Card on file, valid', tone: 'success' },
	EXPIRES_BEFORE_RENEWAL: { label: 'Card expires before the next renewal', tone: 'warning' },
	EXPIRED: { label: 'Card expired', tone: 'danger' },
	PAYMENT_RETRYING: { label: 'Last payment failed, retrying', tone: 'warning' },
	LAST_PAYMENT_FAILED: { label: 'Last payment failed', tone: 'danger' },
	NO_CARD: { label: 'No card on file', tone: 'warning' },
	NOT_CONFIRMED: { label: 'Card saved, details not confirmed', tone: 'neutral' }
});

const BRAND = Object.freeze({ visa: 'Visa', mastercard: 'Mastercard', amex: 'American Express' });

/**
 * The card as shown: a status tag plus, for billing admins, "Visa ending 4242 · expires 08/2028".
 * @param {object|null|undefined} card - the server's `card`
 * @returns {{label: string, tone: string, detail: string|null}|null} null when the server sent no card
 */
export const cardDisplay = (card) => {
	if (!card) return null;
	const s = CARD_STATUS_DISPLAY[card.status] || { label: 'Card status not confirmed', tone: 'neutral' };
	const parts = [];
	if (card.last4) parts.push(`${BRAND[card.brand] || 'Card'} ending ${card.last4}`);
	if (card.expMonth != null && card.expYear != null && card.status !== 'NO_CARD')
		parts.push(`expires ${String(card.expMonth).padStart(2, '0')}/${card.expYear}`);
	return { label: s.label, tone: s.tone, detail: parts.length ? parts.join(' · ') : null };
};

/**
 * The agreement's next renewal or end, from the server's `renewals`.
 * @param {object[]|null|undefined} renewals
 * @returns {{at: string, ends: boolean}|null}
 */
export const agreementRenewal = (renewals) => {
	const r = (renewals || []).find((x) => x?.kind === 'AGREEMENT');
	if (!r) return null;
	if (r.endsAt) return { at: r.endsAt, ends: true };
	if (r.renewsAt) return { at: r.renewsAt, ends: false };
	return null;
};
